import React, { useEffect, useState, useCallback } from 'react';

import PaginationComponent from '../../../components/Pagination/Pagination';
import { NO_PROJECTS, SearchProject } from '../ManageConstants';
import { getManagerProjects } from '../../../services/UserService';
import '../ManageComponent.css';
import GenericLoader from '../../../components/Loader/GenericLoader';
import KeycloakService from '../../../services/KeycloakService';
import ProjectCardComponent2 from '../../../components/ProjectCard/ProjectCardComponent2';
import './ManageProjectComponent.css';
import {
  InputLabel,
  FormControl,
  OutlinedInput,
  InputAdornment,
  IconButton,
  Box,
  Typography,
  Icon,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { Tooltip } from '@mui/material';
import { ManageLoaderAttribute } from '../../../constants';
const ManageProjectsComponent = (props) => {
  const [userMappedProjects, setUserMappedProjects] = useState([]);
  const [loader, setLoader] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearched, setisSearched] = useState(false);
  const currentUserId = () => KeycloakService.getUserDetail();
  const [showError, setShowError] = useState(false);

  const [pageSize, setPageSize] = useState(3);
  const [totalPage, setTotalPage] = useState();
  const [pageNo, setPageNo] = useState(0);
  const [page, setPage] = useState(1);

  const pageChange = async (event, value) => {
    setPage(value);
    const projects = await getManagerProjects(
      currentUserId(),
      searchTerm,
      pageSize,
      value - 1,
    );
    setUserMappedProjects((prevProjects) => [...projects.data.content]);
  };

  const handlePageSizeChange = async (event) => {
    const newPageSize = event.target.value;
    setPageSize(newPageSize);
    setPage(1);
    setLoader(true);
    const projects = await getManagerProjects(
      currentUserId(),
      searchTerm,
      newPageSize,
      0,
    );
    setLoader(false);
    setUserMappedProjects((prevProjects) => [...projects.data.content]);
  };

  const loadData = async () => {
    const projects = await getManagerProjects(
      currentUserId(),
      '',
      pageSize,
      pageNo,
    );
    setUserMappedProjects((prevProjects) => [...projects.data.content]);
    setTotalPage(projects.data.totalPages);
    if (projects?.data?.numberOfElements === 0) {
      setPageNo(0);
      setPage(1);
    }
  };

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 500);
    };
  };

  const clearField = () => {
    setSearchTerm('');
    searchProjectByName('');
  };
  const getProjects = async (pName) => {
    setPageNo(0);
    setPage(1);
    const projectList = await getManagerProjects(
      currentUserId(),
      pName,
      pageSize,
      pageNo,
    );
    console.log(projectList);
    if (projectList?.status === 200) {
      setUserMappedProjects((prevProjects) => [...projectList.data.content]);
      setTotalPage(projectList.data.totalPages);
      if (projectList?.data?.numberOfElements === 0) {
        setPageNo(0);
        setPage(1);
      }
    } else {
      setUserMappedProjects((prevProjects) => []);
      setPageNo(0);
      setPage(1);
    }
    setLoader(false);
  };
  const searchProjectByName = useCallback(debounce(getProjects), []);

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div>
      {loader ? (
        <div>
          <GenericLoader
            rectAttributes={ManageLoaderAttribute}
            showError={showError}
            setShowError={setShowError}
          />
        </div>
      ) : (
        <div>
          <div className="project-search-bar">
            {userMappedProjects.length != 0 || isSearched ? (
              <>
                <Box width="50%">
                  <FormControl sx={{ width: '100%' }} variant="outlined">
                    <InputLabel
                      size="small"
                      htmlFor="outlined-adornment-Project"
                    >
                      {SearchProject}
                    </InputLabel>

                    <OutlinedInput
                      id="outlined-adornment-Project"
                      type="text"
                      size="small"
                      onChange={(e) => {
                        setisSearched(true);
                        setSearchTerm(e.target.value);
                        searchProjectByName(e.target.value.trim());
                      }}
                      value={searchTerm}
                      endAdornment={
                        <InputAdornment position="end">
                          {searchTerm != '' && (
                            <IconButton
                              onClick={clearField}
                              edge="end"
                              size="small"
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          )}
                        </InputAdornment>
                      }
                      label="Search Project"
                    />
                  </FormControl>
                </Box>
                <Tooltip title="Search" arrow>
                  <Icon sx={{ width: '1.25em', height: '1.25em' }}>
                    <SearchIcon />
                  </Icon>
                </Tooltip>
              </>
            ) : (
              ''
            )}
          </div>
          {userMappedProjects.length !== 0 ? (
            userMappedProjects.map((project) => {
              return (
                <ProjectCardComponent2
                  project={project}
                  key={project.projectId}
                  reloadProjects={loadData}
                  setPage={setPage}
                />
              );
            })
          ) : (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '55vh',
              }}
            >
              <div>
                <Typography>{NO_PROJECTS}</Typography>
              </div>
            </div>
          )}

          <Box className="page-holder" sx={{ marginTop: '15px' }}>
            {userMappedProjects.length > 0 ? (
              <PaginationComponent
                count={totalPage}
                page={page}
                pageChange={pageChange}
                pageSize={pageSize}
                handlePageSizeChange={handlePageSizeChange}
              />
            ) : (
              ''
            )}
          </Box>
        </div>
      )}
    </div>
  );
};

export default ManageProjectsComponent;
